export const PATH_PAGE = {
  page404: '/404',
  privacyPolicy: '/privacy-policy',
  termsOfUse: '/terms-of-use',
};
